export const BURGER_MENU = 'burger-menu';
export const BURGER_MENU_ROOT = 'burger-menu-root';
export const BURGER_MENU_CONTAINER = 'burger-menu-container';
export const BURGER_MENU_TAB_ROOT = 'burger-menu-tab-root';
export const BURGER_MENU_TAB_ICON_WRAPPER = 'burger-menu-tab-icon-wrapper';
export const TAB_ICON = 'tab-icon';
export const BURGER_MENU_TAB_LABEL_WRAPPER = 'burger-menu-tab-label-wrapper';
export const BURGER_MENU_LINK = 'burger-menu-link';
export const BURGER_MENU_LINK_ROOT_MOBILE = 'burger-menu-link-root-mobile';
export const BURGER_MENU_LINK_CATEGORY_MOBILE = 'burger-menu-link-category-mobile';
export const BURGER_MENU_LINK_ICON_WRAPPER = 'burger-menu-link-icon-wrapper';
export const BURGER_MENU_CONTENT = 'burger-menu-content';
export const BURGER_MENU_LINK_ROOT = 'burger-menu-link-root';
export const BURGER_MENU_LINK_CATEGORY = 'burger-menu-link-category';
export const BURGER_MENU_TOGGLE_ROOT = 'burger-menu-toggle-root';
export const BURGER_MENU_CONTENT_ROOT = 'burger-menu-content-root';
export const CATEGORY_WRAPPER = 'category-wrapper';
export const BURGER_MENU_BACKDROP = 'burger-menu-backdrop';
